import { render, staticRenderFns } from "./ownerExitRoom.vue?vue&type=template&id=30b235de&scoped=true"
import script from "./ownerExitRoom.vue?vue&type=script&lang=js"
export * from "./ownerExitRoom.vue?vue&type=script&lang=js"
import style0 from "./ownerExitRoom.vue?vue&type=style&index=0&id=30b235de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b235de",
  null
  
)

export default component.exports